import "./footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <hr />
      <div className="disclaimer">
        <p>
          ZFD Notary Services <span>©</span> 2025 | All rights reserved
        </p>
        <p>
          ZFD Notary Services provides in-person commissioning in compliance
          with the laws and regulations of Ontario, Canada. Our services are
          performed by a licensed legal professional.
        </p>
        <p>
          ZFD Notary Services is not a law firm and does not provide legal
          advice, legal representation, or legal opinions. We cannot offer legal
          guidance on the validity, enforceability, or acceptance of documents
          by third parties.
        </p>
      </div>

      <div className="jmd">
        Website by{" "}
        <a href="https://jmdiaz.dev/" target="_blank">
          jmdiaz.dev
        </a>
      </div>
    </div>
  );
}
